import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { teal400, teal500, teal600 } from 'material-ui/styles/colors';
import BreadCrumb from '../../components/BreadCrumb';
import MultiStateSwitch from '../../components/MultiStateSwitch';
import { TopBarHints } from '../../resources/hints';
import { clearImageSelection } from '../../actions/SearchFieldActions';
import { toggleAside, switchGridImageSize } from '../../actions/UIActions';

import './TopBar.sass';

class TopBar extends Component {
  constructor(props) {
    super(props);
    this.mapPathnameToCrumbs = this.mapPathnameToCrumbs.bind(this);
    this.handleSwitchGridImageSize = this.handleSwitchGridImageSize.bind(this);
    this.handleDirectBatchSearch = this.handleDirectBatchSearch.bind(this);
  }

  mapPathnameToCrumbs() {
    const { pathname, search } = this.props.history.location;

    if ((new RegExp('^/images/grid$')).test(pathname)) {
      return [{ value: 'Images', path: `${pathname}${search}` }];
    } else if ((new RegExp('^/images/grid/[0-9]+')).test(pathname)) {
      return [{ value: 'Images', path: `/images/grid${search}` }, { value: 'Single Image Evaluation', path: pathname }];
    } else if ((new RegExp('^/images/batch_evaluation'))) {
      return [{ value: 'Images', path: `/images/grid${search}` }, { value: 'Batch Image Evaluation', path: pathname }];
    }
    return [{ value: 'Images', path: `/images/grid${search}` }];
  }

  handleSwitchGridImageSize({ value }) {
    const { dispatch } = this.props;
    dispatch(switchGridImageSize(value));
  }

  handleDirectBatchSearch() {
    const { dispatch, history } = this.props;
    history.push('/images/batch_evaluation');
    dispatch(clearImageSelection());
  }

  isImageGridPage() {
    const { history: { location: { pathname } } } = this.props;
    return /\/images\/(grid|list)/.test(pathname);
  }

  render() {
    const {
      dispatch,
      showAside,
      gridImageSize,
      gridImageSizeSwitchConfig
    } = this.props;
    /* Rendering the detailed configurator */
    const renderGridConfigurator = (
      <MultiStateSwitch
        types={gridImageSizeSwitchConfig}
        showTitle={false}
        value={gridImageSize}
        onStateChange={this.handleSwitchGridImageSize}
        {...TopBarHints.gridImageSizeHint}
      />
    );

    return (
      <div className={`TopBar ${showAside ? 'show-aside' : ''}`}>
        <div className={`aside-toggler-wrapper ${showAside ? 'show-aside' : ''}`}>
          <button onClick={() => dispatch(toggleAside())}>
            <span className="fa fa-chevron-right" /> Search Fields
          </button>
        </div>

        <BreadCrumb
          data={this.mapPathnameToCrumbs()}
          style={{ height: '50pt', lineHeight: '50pt' }}
        />

        <div className="right-section">
          {
            this.isImageGridPage() && (
              <div className="switches">
                {renderGridConfigurator}
              </div>
            )
          }
        </div>
      </div>
    );
  }
}

TopBar.propTypes = {
  dispatch: PropTypes.func.isRequired,
  showAside: PropTypes.bool.isRequired,
  gridImageSize: PropTypes.oneOf(['small', 'medium', 'large']).isRequired,
  gridImageSizeSwitchConfig: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string,
    value: PropTypes.oneOf(['small', 'medium', 'large']),
    fontAwesomeIcon: PropTypes.string,
    color: PropTypes.string
  })),
  history: PropTypes.object.isRequired
};

TopBar.defaultProps = {
  gridImageSizeSwitchConfig: [
    {
      title: 'Small',
      value: 'small',
      fontAwesomeIcon: 'picture-o',
      color: teal400,
      iconStyle: { fontSize: '60%' }
    },
    {
      title: 'Medium',
      value: 'medium',
      fontAwesomeIcon: 'picture-o',
      color: teal500,
      iconStyle: { fontSize: '80%' }
    },
    {
      title: 'Large',
      value: 'large',
      fontAwesomeIcon: 'picture-o',
      color: teal600,
      iconStyle: { fontSize: '100%' }
    }
  ]
};

function mapStateToProps(store) {
  const { UI: { showAside, gridImageSize } } = store;

  return {
    showAside,
    gridImageSize
  };
}

export default withRouter(connect(mapStateToProps)(TopBar));



// WEBPACK FOOTER //
// ./src/containers/TopBar/TopBar.jsx